export
const name: string = "Opaque";

export
const preproc: string = ``;

export
const declaration: string = `
    attribute vec3  a_position;

    #if !defined(CHUNK_LOD)
    attribute float a_manipulation;
    #endif

    #if !defined(PRIMITIVE_ID_PASS) && !defined(CHUNK_LOD)
    attribute float a_visibility;
    #endif

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
    attribute vec3 a_normal;
    #if !defined(CHUNK_LOD)
    attribute float a_selection;
    #endif
    #endif

    #if defined(PRIMITIVE_ID_PASS) && !defined(CHUNK_LOD)
    attribute float a_primitive_id;
    #endif

    #if defined(TEXTURED)
    attribute vec2 a_tex_coord;

    #if defined(CHUNK_LOD)
    attribute float a_layer;
    #endif

    #endif

    uniform vec3 u_view_vector;
    uniform mat4 u_view_projection;
    uniform mat4 u_model_transformation; // this supply the model in model view projectionm matrix as we do not have per mesh model trafo, but met fat model

    #if defined(MANIPULATOR_ENABLED) && !defined(CHUNK_LOD)
    uniform mat4 u_manipulator;
    #endif

    #if defined(CHUNK_LOD)
    uniform vec4 u_tex_trafo;
    uniform float u_glod_level_size;
    uniform vec2 u_glod_position_offset;
    #endif
`;

export
const varyings: string = `
    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
    varying float v_selected;
    #endif

    #if defined(PRIMITIVE_ID_PASS)
    varying vec4 v_primitive_id;
    #endif

    #if defined(TEXTURED)
    varying vec2    v_tex_coord;
    #endif
`;

export
const implementation: string = `
    void main()
    {
    #if defined(PRIMITIVE_ID_PASS) // special handling of primitive id pass where we does not have visibility
        vec4 position = vec4(a_position, 1.0);
    #else // all other case opaque and depth and xray ?

        #if !defined(CHUNK_LOD)
            vec4 position = vec4(a_position, 1.0) * a_visibility;
        #else
            vec4 position = vec4(a_position.x + u_glod_position_offset.x, a_position.y, a_position.z + u_glod_position_offset.y, 1.0);
        #endif
    #endif

    #if defined(MANIPULATOR_ENABLED) && !defined(CHUNK_LOD)
        if (a_manipulation > 0.5) {
            position = u_manipulator * position;
        }
    #endif

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS) && defined(XRAY)
         vec3 vNormal = normalize(a_normal);
         vec3 vNormel = normalize(u_view_vector);
         float c = 0.0;
         float p = 8.0;
         v_intensity = pow(c-dot(vNormal, vNormel), p);//0.0;////pow(c - dot(vNormal, vNormel), p);

         if (v_intensity < 0.05) v_intensity = 0.05;
         if (v_intensity > 0.1) v_intensity = 0.1;
    #endif

    #if !defined(HUD)
        gl_Position = u_view_projection * u_model_transformation * position;
    #else
        gl_Position = vec4(a_position.xy, 0.0, 1.0);
    #endif

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS) && !defined(CHUNK_LOD)
        v_selected  = a_selection;
    #endif

    #if defined(PRIMITIVE_ID_PASS)
        v_primitive_id = intToVec4(a_primitive_id);
    #endif

    #if defined(CHUNK_LOD) && defined(TEXTURED)
        // the a_layer is layer at the highest level for each point
        float layer_offset = mod(a_layer, u_glod_level_size) / u_glod_level_size;

        v_tex_coord = vec2(layer_offset + (a_tex_coord[0] - u_tex_trafo[0]) * u_tex_trafo[2], 1.0 - ((a_tex_coord[1] - u_tex_trafo[1]) * u_tex_trafo[3]));
    #elif defined(TEXTURED)
        v_tex_coord = vec2(a_tex_coord[0], a_tex_coord[1]);
    #endif

    #if defined(HUD)
        setVaryingsForLighting0();
    #elif !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
        setVaryingsForLighting2(a_normal, position, u_view_projection * u_model_transformation * position);
    #endif

    #ifdef CLIPPING_PLANE
        setVaryingsForCPlane(u_model_transformation * position);
    #endif

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS) && defined(LOGDEPTH)
        setVaryingsForLogarithmicDepthBuffer();
    #endif
    }
`;
